import Mail from '@/assets/svg/icons/mail.svg';
import Clock from '@/assets/svg/icons/clock.svg';
import AtSign from '@/assets/svg/icons/at-sign.svg';
import Link from '@/assets/svg/icons/link.svg';
import AlertTriangle from '@/assets/svg/icons/alert-triangle.svg';
import Check from '@/assets/svg/icons/check.svg';
import Heart from '@/assets/svg/icons/heart.svg';
import Minus from '@/assets/svg/icons/minus.svg';
import CheckSquare from '@/assets/svg/icons/check-square.svg';
import CheckCircle from '@/assets/svg/icons/check-circle.svg';
import FileText from '@/assets/svg/icons/file-text.svg';
import Film from '@/assets/svg/icons/film.svg';
import Image from '@/assets/svg/icons/image.svg';
import File from '@/assets/svg/icons/file.svg';
import List from '@/assets/svg/icons/list.svg';
import MessageCircle from '@/assets/svg/icons/message-circle.svg';
import Folder from '@/assets/svg/icons/folder.svg';
import CustomSVG from '@/components/common/svg';

export function getColumnNames() {
    return {
        name: "Név", 
        email: "E-mail",
        invitation: "Meghívó",
        phone: "Elérhetőség"
    }
}

export function getGuestOptions() {
    return [
        {id: 1, name: "Alapadatok", value: "data"},
        {id: 2, name: "Üzenetek", value: "messages"}
    ]
}

export function getWebsiteEventOptions() {
    return [
        {id: 'Igen'},
        {id: 'Nem'},
        {id: 'Talán'}
    ]
}

export function getEventOptions() {
    return [
        {id: 1, name: "invited"},
        {id: 2, name: "attending"},
        {id: 3, name: "declined"}, 
        {id: 4, name: "empty"}
    ];
}

export function getEventNames() {
    return {
        invited: "Talán",
        attending: "Jön",
        declined: "Nem jön",
        empty: "Nem meghívott"
    }
}

export function getInvitationNames() {
    return {
        "not-sent": "Visszajelzésre vár",
        "sent": "Meghívó kiküldve",
        "connected-user": "Össekapcsolt felhasználó",
        "no-email": "Nincs hozzárendelt e-mail cím"
    }
}

export function getInvitationIcons() {
    return {
        "not-sent": {icon: Clock, type: "warning"},
        "sent": {icon: Mail, type: "success"},
        "connected-user": {icon: Link, type: "gray"},
        "no-email": {icon: AtSign, type: "error"}
    }
}

export function getTaskStatusNames() {
    return {
        "todo": "Teendő",
        "done": "Teljesített"
    }
}

export function getTaskStatusIcons() {
    return {
        "todo": {icon: AlertTriangle, type: "warning"},
        "done": {icon: Check, type: "success"}
    }
}

export function getBudgetStatuses() {
    return {
        "planned": {name: "Tervezett", type: "warning"},
        "ordered": {name: "Megrendelt", type: "blue-light"},
        "paid": {name: "Fizetett", type: "success"}
    }
}

export function getProviderStatuses() {
    return {
        "like": {name: "Tetszik", type: "success", icon: Heart},
        "selected": {name: "Kiválasztott", type: "success", icon: Heart},
        "archiv": {name: "Archivált", type: "error", icon: Minus}
    }
}

const provider_category_icons = {
    "check-square": CheckSquare,
    "check-circle": CheckCircle,
    "mail": Mail,
    "file-text": FileText
}

export function getProviderCategoryIcon(icon) {
    if(provider_category_icons[icon]) return provider_category_icons[icon];
    else return CheckSquare;
}

export function getProviderDefaultLocationDatas() {
    return {
        provider_name: "",
        address_zip: "",
        address_city: "",
        address_street: ""
    }
}

export function getProviderTabs() {
    return [
        {id: 1, name: "Alapadatok", value: "data"},
        {id: 2, name: "Üzenetek", value: "messages"},
        // {id: 3, name: "Csatolmányok", value: "attachments"}
    ]
}

const file_type_icons = {
    video: Film,
    image: Image,
}

export function getFileTypeIcon(icon) {
    let parts = icon.trim().split("/");
    if(file_type_icons[parts[0]]) return file_type_icons[parts[0]];
    else return File;
}

export function getMessageTabs() {
    return [
        {id: 1, name: "Összes", value: "all"},
        {id: 2, name: "Szolgáltatók", value: "providers"},
        {id: 3, name: "Násznép", value: "guests"}
    ]
}

export function getCountySeats() {
    return [
        {city: "Békéscsaba"},
        {city: "Budapest"},
        {city: "Debrecen"},
        {city: "Eger"},
        {city: "Győr"},
        {city: "Kaposvár"},
        {city: "Miskolc"},
        {city: "Nyíregyháza"},
        {city: "Pécs"},
        {city: "Salgótarján"},
        {city: "Szeged"},
        {city: "Szekszárd"},
        {city: "Székesfehérvár"},
        {city: "Szolnok"},
        {city: "Szombathely"},
        {city: "Tatabánya"},
        {city: "Veszprém"},
        {city: "Zalaegerszeg"}
    ]
}

export function getSearchParamsExceptions() {
    return ["order", "per_page", "page"];
}

export function getPerPageOptions() {
    return [
        {name: "6 találat", value: 6},
        {name: "12 találat", value: 12},
        {name: "24 találat", value: 24},
        {name: "60 találat", value: 60}
    ];
}

export function getSortOptions() {
    return [
        {name: "Név szerint", value: "name"}
    ]
}

export function getActiveOrInactiveBadge() {
    /*return {
        "active": {name: "Aktív", color: "success", icon: Check},
        "inactive": {name: "Inaktív", color: "warning", icon: AlertTriangle}
    }*/
    return {
        1: {color: "success", icon: Check},
        2: {color: "warning", icon: AlertTriangle}
    }
}

export function getDefaultAcceptedImages() {
    return {
        'image/jpeg': [],
        'image/png': [],
        'image/webp': []
    }
}

export function getEarlyVersionWeddingHalls() {
    return {
        id: 325,
        name: 'Házasságkötő terem',
        description: '',
        url: 'hazassagkoto-terem'
    }
    
}

export function getWebsiteSectionTypes() {
    return [
        {
            "type": "hero",
            "name": "Üdvözlünk",
            "has_nav": true
        },
        {
            "type": "event",
            "name": "Programok",
            "has_nav": true
        },
        {
            "type": "event_dynamic",
            "name": "Program",
            "has_nav": true
        },
        {
            "type": "rsvp",
            "name": "Visszajelzés",
            "has_nav": true
        },
        {
            "type": "contact",
            "name": "Kapcsolat",
            "has_nav": true
        },
        {
            "type": "location",
            "name": "Elhelyezkedés",
            "has_nav": true
        },
        {
            "type": "accommodation",
            "name": "Szállás",
            "has_nav": true
        },
        {
            "type": "countdown",
            "name": "Visszaszámlálás",
            "has_nav": true
        },
        {
            "type": "custom_text",
            "name": "Egyedi - szöveges",
            "has_nav": true
        },
        {
            "type": "other",
            "name": "Egyéb",
            "has_nav": true
        }
    ]
}

export function getNotificationOptions() {
    return [
        {id: 1, name: "Esküvő szervezőm", value: "users"},
        {id: 2, name: "Hirdetéseim", value: "providers"}
    ]
}

export function getNotificationOptionsProvider() {
    return [
        {id: 2, name: "Hirdetéseim", value: "providers"}
    ]
}

export function getRecaptchaPages() {
    return ["/szolgaltato/regisztracio",
         "/bejelentkezes",
          "/elfelejtett-jelszo",
           "/regisztracio",
            "/szolgaltato-bejelentkezes",
             "/uj-jelszo",
                            "/weboldal",
              "/[provider_type]", 
              "/[provider_type]/[provider_city]",
              "/[provider_type]/[provider_city]/[provider_id]"
            ];
}

export function getMessageStatusoptions(empty) {
    let temp = [
        {id: 1, val: "notsent", name: "Válaszra vár", theme: "warning"},
        {id: 2, val: "sent", name: "Ajánlatkérés elküldve", theme: "success"}
    ]

    if(empty) temp = [
        {id: 0, val: "", name: "-", theme: "gray"},
        ...temp
    ]

    return temp;
}

export function getProviderLinks() {
    return [
        {icon: <CustomSVG className={`stroke-gray-800 circle-gray-800 flex-shrink-0`} SvgFunction={List} height={24} width={24} />, name: "Hirdetések", href: `/hirdetoi-fiok/hirdeteseim`, guard_unsaved: true},
        {icon: <CustomSVG className={`stroke-gray-800 circle-gray-800 flex-shrink-0`} SvgFunction={MessageCircle} height={24} width={24} />, name: "Üzenetek", href: `/hirdetoi-fiok/uzenetek`, guard_unsaved: true},
        {icon: <CustomSVG className={`stroke-gray-800 circle-gray-800 flex-shrink-0`} SvgFunction={FileText} height={24} width={24} />, name: "Sablonok", href: `/hirdetoi-fiok/sablonok`, guard_unsaved: true},
        {icon: <CustomSVG className={`stroke-gray-800 circle-gray-800 flex-shrink-0`} SvgFunction={Folder} height={24} width={24} />, name: "Tárhely", href: `/hirdetoi-fiok/tarhely`, guard_unsaved: true},
    ];
}